import { render, staticRenderFns } from "./ConfirmAppointmentMessages.vue?vue&type=template&id=1d6dec34&scoped=true&"
import script from "./ConfirmAppointmentMessages.vue?vue&type=script&lang=js&"
export * from "./ConfirmAppointmentMessages.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAppointmentMessages.vue?vue&type=style&index=0&id=1d6dec34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6dec34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VProgressLinear})
